/**
 * 訪客 id：沒登入的人也能在留言專區按讚、在許願清單投票，用這個 id 區分「誰按過」（同一個瀏覽器只算一次）
 * 存在 localStorage；換帳號登入時 ensureCacheOwner 會清掉，那時已經登入、改用帳號身分
 */
const KEY = 'feedback-visitor-id';

export const getVisitorId = (): string => {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved) return saved;
    const id = crypto.randomUUID();
    localStorage.setItem(KEY, id);
    return id;
  } catch {
    return ''; // localStorage 不可用（無痕被封鎖）：訪客不能按讚／投票，其餘照常
  }
};
